<template>
  <PaginationWrapper
    :page="page"
    :pageSize="50"
    :totalCount="totalCount"
    @onPageChange="handlePageChange"
    export
    @exportTable="exportList"
  >
    <LogsOCPPSearchOptions @onSearch="handleSearch" slot="search-options" />
    <div slot="table">
      <span class="section-title">
        {{ $t("sections.errorsList.table.title") }}
      </span>
      <LogsTableOCPP />
    </div>
  </PaginationWrapper>
</template>
<script>
import PaginationWrapper from '@/components/sections/common/PaginationWrapper.vue';
import LogsTableOCPP from '@/components/sections/logs/LogsTableOCPP';
import LogsOCPPSearchOptions from '@/components/sections/logs/LogsOCPPSearchOptions';

export default {
  name: 'OCPPLogsList',
  components: {
    PaginationWrapper,
    LogsTableOCPP,
    LogsOCPPSearchOptions,
  },
  data() {
    return {
      query: {},
      activeTab: 0,
      page: 1,
      totalCount: 0,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.$store.dispatch('storeLoading', true);
      if (Object.keys(this.query).length === 0) {
        this.query.startDate = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000);
        this.query.endDate = new Date();
      }
      this.totalCount = await this.$store.dispatch('storeLogsOCPP', {
        query: {
          ...this.query,
          component: 'OCPP',
        },
        page: this.page,
      });
      this.$store.dispatch('storeLoading', false);
    },
    async handleSearch(query) {
      this.page = 1;
      this.query = query;
      await this.fetchData();
    },
    async handlePageChange(page) {
      this.page = page;
      await this.fetchData();
    },
    async exportList() {
      await this.$store.dispatch('storeLoading', true);

      try {
        const file = await this.$store.dispatch('exportList', {
          query: {
            ...this.query,
            component: 'OCPP',
          },
          type: 'locationLogs',
        });

        if (file.data === '') {
          this.$message.error(
            this.$t('components.alerts.exportFileError', {
              type: 'locationLogs',
            }),
          );
        } else {
          const fileURL = window.URL.createObjectURL(new Blob([file.data]));
          const fileLink = document.createElement('a');

          fileLink.href = fileURL;
          fileLink.setAttribute(
            'download',
            `locationLogs-${new Date()
              .toISOString()
              .slice(0, 10)
              .replaceAll('-', '')}.csv`,
          );
          document.body.appendChild(fileLink);

          fileLink.click();
          this.$message.success(
            this.$t('components.alerts.exportSuccess', { type: 'locationLogs' }),
          );
        }
      } catch (e) {
        this.$message.error(
          this.$t('components.alerts.exportError', { type: 'locationLogs' }),
        );
        console.log(e);
      }

      await this.$store.dispatch('storeLoading', false);
    },
  },
};
</script>
